import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from '../../../../reducers';
import { DialogService } from '../../../../services/dialog.service';
import { AddFilterDialogMessages, ConfirmationMessage, ConfirmationResult, ModalFullWidthMode } from '../../../../shared/_constants';
import {
  isLoading,
  selectSelectedCompanies,
  selectSelectedCompaniesCount,
  selectTotalCount,
} from '../../sections/company-search/company-search.selectors';
import { clearState, updateTabIndex } from './company-slide-out.actions';
import { selectActiveTabIndex } from './company-slide-out.selectors';

@Component({
  selector: 'app-company-slide-out',
  templateUrl: './company-slide-out.component.html',
  styleUrls: ['./company-slide-out.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class CompanySlideOutComponent implements OnInit, OnDestroy {
  isFullScreen = false;
  hasItemsLoaded: boolean;
  activeTabIndex: number;
  selectedCompanies: any[];
  companySelected = false;

  loading$: Observable<boolean>;
  selectedCompaniesCount$: Observable<number>;

  destroy$ = new Subject();

  constructor(private activeModal: NgbActiveModal, private dialogService: DialogService, private store: Store<AppState>) {}

  ngOnInit(): void {
    this.loading$ = this.store.pipe(select(isLoading));
    this.selectedCompaniesCount$ = this.store.pipe(select(selectSelectedCompaniesCount));

    this.store
      .pipe(takeUntil(this.destroy$))
      .pipe(select(selectSelectedCompanies))
      .subscribe((companies) => {
        this.selectedCompanies = companies;
      });

    this.store
      .pipe(takeUntil(this.destroy$))
      .pipe(select(selectTotalCount))
      .subscribe((totalCount) => {
        this.hasItemsLoaded = totalCount > 0;
        this.disableDrillDownTab(totalCount);
      });

    this.store
      .pipe(takeUntil(this.destroy$))
      .pipe(select(selectActiveTabIndex))
      .subscribe((index) => {
        this.activeTabIndex = index;
        this.enableDrillDownTab(index);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next('');
    this.store.dispatch(clearState());
  }

  addCompanies() {
    this.activeModal.close(this.selectedCompanies);
  }

  async close() {
    if (this.hasItemsLoaded) {
      const result = await this.dialogService.confirm(
        AddFilterDialogMessages.DIALOG_CONFIRM_MSG,
        ConfirmationMessage.ConfirmCompanySlideOutClose,
        AddFilterDialogMessages.DIALOG_CONFIRM_RESULT_YES_MSG,
        AddFilterDialogMessages.DIALOG_CONFIRM_RESULT_NO_MSG
      );
      if (result === ConfirmationResult.yes) {
        this.activeModal.close();
      }
    } else {
      this.activeModal.close();
    }
  }

  resize() {
    const modal = document.getElementsByClassName(this.isFullScreen ? ModalFullWidthMode.FULL_SCREEN_CSS_CLASS : ModalFullWidthMode.CSS_CLASS)[0];

    if (this.isFullScreen) {
      modal.classList.remove(ModalFullWidthMode.FULL_SCREEN_CSS_CLASS);
      modal.classList.add(ModalFullWidthMode.CSS_CLASS);
      modal.classList.add(ModalFullWidthMode.FULL_SCREEN_EXIT_CSS_CLASS);
    } else {
      modal.classList.add(ModalFullWidthMode.FULL_SCREEN_CSS_CLASS);
      modal.classList.remove(ModalFullWidthMode.CSS_CLASS);
      modal.classList.remove(ModalFullWidthMode.FULL_SCREEN_EXIT_CSS_CLASS);
    }

    this.isFullScreen = !this.isFullScreen;
  }

  handleChange(e) {
    this.store.dispatch(updateTabIndex({ index: e.index }));
  }

  disableDrillDownTab(totalCount: number) {
    if (totalCount === 0 && this.companySelected) {
      this.companySelected = false;
    }
  }

  enableDrillDownTab(index: number) {
    if (index !== 0 && !this.companySelected) {
      this.companySelected = true;
    }
  }
}
